import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import qs from "querystring";
import GlobalDatePickerVisibilityActions from "../../../actions/GlobalDatePickerVisibilityActions";
import { useDateRangeFilterStore } from "../../../storez/DateRangeFilterStore";
import Api from "../../../utils/Api";
import UserJourneyNew from "./UserJourneyNew";
import { useReportingUserStore } from "../../../storez/ReportingUserStore";
import { withToast } from "../../../utils/ReactUtil";

class UserJourney extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      journeyData: [],
      loaded: false,
      initialResultFilter: props.location.query.verdict,
      user: undefined,
    };
    this.tableRef = React.createRef();
    this.unsubFilterStore = null;
  }

  componentDidMount() {
    const self = this;

    void useReportingUserStore
      .getState()
      .getUser(this.props.params.user)
      .then(
        (user) => {
          self.setState({ user });
          self.getJourneyData();
        },
        (err) => {
          if ("status" in err && (err.status === 403 || err.status === 404)) {
            self.context.router.replace("/config/device/forbidden");
          } else {
            self.props.errorToast({
              title: "Please try again",
              description: "Failed to load student data. If the issue persists, please contact support.",
              isClosable: true,
            });
          }
        }
      );

    this.unsubFilterStore = useDateRangeFilterStore.subscribe(this.getJourneyData);
    setTimeout(GlobalDatePickerVisibilityActions.showGlobalDatePicker, 0);
  }

  componentWillUnmount() {
    this.unsubFilterStore();
  }

  getJourneyData = () => {
    let self = this;
    if (this.state.loaded) {
      this.setState({
        loaded: false,
      });
    }

    const startDate = moment(`${useDateRangeFilterStore.getState().getStartDate()} ${useDateRangeFilterStore.getState().getStartTime()}`);
    const endDate = moment(`${useDateRangeFilterStore.getState().getEndDate()} ${useDateRangeFilterStore.getState().getEndTime()}`);
    this.setState({ startDate, endDate, selectedStart: startDate, selectedEnd: endDate });

    Api.get_analytics(
      `/surfwize/analytics/users/${this.state.user.username}/journey`,
      function (result) {
        const categories = [];
        result.data.forEach((item) => {
          if (item.signature_name !== null && item.signature_name.length > 0) {
            item.signature_name.forEach((signature) => {
              if (!categories.includes(signature)) {
                categories.push(signature);
              }
            });
          }
        });

        self.setState({
          journeyData: result.data,
          loaded: true,
        });
      },
      function (error) {
        self.setState({
          journeyData: [],
          loaded: true,
        });
      }
    );
  };

  render() {
    const dateTimeParams =
      this.state.selectedStart &&
      this.state.selectedEnd &&
      qs.stringify({
        overrideDates: "t",
        startDate: this.state.selectedStart.format("YYYY-MM-DD"),
        startTime: this.state.selectedStart.format("HH:mm:ss"),
        endDate: this.state.selectedEnd.format("YYYY-MM-DD"),
        endTime: this.state.selectedEnd.format("HH:mm:ss"),
      });

    return (
      <UserJourneyNew
        data={this.state.journeyData}
        user={this.state.user}
        loaded={this.state.loaded}
        dateTimeParams={dateTimeParams}
        initialResultFilter={this.state.initialResultFilter}
      />
    );
  }
}

UserJourney.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default withToast(UserJourney);
